import React, { useEffect } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';

import { LbDatePicker } from '@infoods/lifebase-ui';
import classes from './ModalInputs.module.scss';
import { SelectorsGroup } from '../SelectorsGroup/SelectorsGroup';
import { ReportSetting } from '../../../../../interfaces/ReportSetting';

type ModalInputsProps = {
  selectorsSettings: ReportSetting[];
  reportType: string;
};

const ModalInputs = ({ selectorsSettings, reportType }: ModalInputsProps) => {
  const { control, reset } = useFormContext();
  const startDate = useWatch({ name: 'from' });

  useEffect(() => reset, [reset]);

  const dateFormat = 'MM.DD.YYYY';

  const defaultDatePickerProps = {
    control,
    defaultToday: true,
    disableFuture: true,
    format: dateFormat,
    openTo: 'month',
  } as const;

  return (
    <div>
      <SelectorsGroup selectors={selectorsSettings} reportType={reportType} />
      <div className={classes.datePickerBox}>
        <LbDatePicker
          {...defaultDatePickerProps}
          name="from"
          label="Start Date"
          rules={{ required: 'Start Date is required' }}
        />
        <LbDatePicker
          {...defaultDatePickerProps}
          name="to"
          label="End Date"
          minDate={moment(startDate, dateFormat)}
          rules={{ required: 'End Date is required' }}
        />
      </div>
    </div>
  );
};

export { ModalInputs };
